import { IonContent } from '@ionic/react';
import ModalWrapper from '../../components/modals/ModalWrapper';
import { FC, ReactNode } from 'react';
import { IModal } from '../../router/ModalRouter';
import { OfferModalProps } from '../../../../services/exports/Interfaces';
import DefaultOfferModal from '../../../../modals/offer/OfferModal';
import useModalRouter from '../../common/hooks/useModalRouter';

const OfferModal: FC<Partial<IModal> & OfferModalProps> = (props): ReactNode => {
  const { closeModal } = useModalRouter();

  return (
    <ModalWrapper>
      <IonContent className="min-h-[90dvh]">
        <DefaultOfferModal {...props} onClose={closeModal} />
      </IonContent>
    </ModalWrapper>
  );
};

export default OfferModal;
